export enum ClassificationType {
  STANDARD = 'standard',
  COMPOSITE = 'composite',
  VARIANT = 'variant',
}
